import { Formik } from 'formik'
import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import uniqBy from 'lodash/uniqBy'
import styled from 'styled-components'
import * as Yup from 'yup'
import FullPageLoading from 'components/FullPageLoading'
import Button from 'components/Button'
import { _ } from 'utils'
import { QueryResponse } from 'utils/graphql'
import TextField from '../TextField'
import { showErrorNotification, showNotification } from '../../../notifications/notificationsSlice'
import SubmitButton from '../SubmitButton'
import { preventSubmitOnEnter } from '../../utils'

const S = {
    Actions: styled.div`
        display: flex;
        justify-content: flex-end;
        width: 100%;
        padding-right: 10px;
    `,
}

interface InviteFormProps {
    close: () => void
    name: string
    onSubmit?: (email: string) => Promise<QueryResponse<any>>
    callback?: () => void
    setNewAddedItems?: (e?: any) => void
}

const EmailValidation = Yup.object().shape({
    invitedEmail: Yup.string().email().required()
})

const InviteEmailForm = ({
    close, onSubmit, callback, setNewAddedItems
}: InviteFormProps) => {
    const dispatch = useDispatch()
    const [isUploading, setIsUploading] = useState(false)
    const handleSubmit = async (values) => {
        setIsUploading(true)
        const response = await onSubmit(values.invitedEmail)
        setIsUploading(false)
        if (!response.data || response.errors.length) {
            dispatch(showErrorNotification(response.errors))
            return
        }

        dispatch(showNotification({
            type: 'success',
            body: _('form.notification.invite_success')
        }))
        setNewAddedItems((items) => uniqBy([
            ...items,
            {
                id: -(Math.floor(Math.random() * 10000) + 1), // Random from -10000 -> -1
                email: values.invitedEmail,
                hasLoggedOn: false,
            }
        ], 'email'))
        callback?.()
        close()
    }

    return (
        <Formik
            initialValues={{
                invitedEmail: ''
            }}
            onSubmit={handleSubmit}
            validationSchema={EmailValidation}
        >
            <>
                <Form className="row" onKeyPress={preventSubmitOnEnter}>
                    <TextField
                        name="invitedEmail"
                        label={_('form.email_address')}
                        isRequired
                    />
                    <S.Actions>
                        <Button variant="secondary" onClick={close}>{_('button.cancel')}</Button>
                        <SubmitButton text={_('button.send_invite')} />
                    </S.Actions>
                </Form>
                {isUploading && <FullPageLoading isAbsolute fullWidth />}
            </>
        </Formik>
    )
}

export default InviteEmailForm
